import { render, staticRenderFns } from "./Dissertation_council_member.vue?vue&type=template&id=2d8568b8&scoped=true"
import script from "./Dissertation_council_member.vue?vue&type=script&lang=js"
export * from "./Dissertation_council_member.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8568b8",
  null
  
)

export default component.exports